// extracted by mini-css-extract-plugin
export var actions = "_tk-4";
export var item = "_tk-1";
export var price = "_tk-3";
export var quantity = "_tk-2";
export var table = "_tk-0";